

export class TimeoutHelper {

    /**
    *
    * @param milliseconds
    */
    public static async sleep(milliseconds: number): Promise<void> {
      return new Promise<void>(_resolve => {
        setTimeout(() => {
          _resolve();
        }, milliseconds);
      });
    }
}
